<template>
  <div class="notice-detail-page">
    <Header></Header>
    <Nav></Nav>
    
    <div class="detail-container">
      <div class="detail-card">
        <div class="back-btn" @click="goBack">
          <span>&lt; 返回</span>
        </div>
        
        <div v-if="loading" class="loading">加载中...</div>
        
        <div v-else-if="error" class="error">
          <p>{{ error }}</p>
          <button @click="fetchDetail">重试</button>
        </div>
        
        <div v-else class="detail-content">
          <h1 class="detail-title">{{ notice.noticeTitle }}</h1>
          <div class="detail-meta">
            <span class="detail-date">发布时间：{{ notice.createTime }}</span>
          </div>
          <div class="detail-body" v-html="notice.noticeContent"></div>
        </div>
      </div>
    </div>
    
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/head.vue";
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
import { getNoticeDetail } from "@/api/home";

export default {
  name: "NoticeDetail",
  components: { Header, Nav, Footer },
  data() {
    return {
      notice: {},
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      this.error = null;
      try {
        const id = this.$route.params.id;
        const res = await getNoticeDetail(id);
        if (res.code === 0 && res.data) {
          this.notice = res.data;
        } else {
          this.error = res.msg || "获取详情失败";
        }
      } catch (e) {
        this.error = "网络错误，请重试";
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.fetchDetail();
  },
};
</script>

<style scoped>
.detail-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.detail-card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.back-btn {
  color: #004080;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 14px;
}
.back-btn:hover {
  text-decoration: underline;
}
.detail-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #004080;
  padding-bottom: 15px;
}
.detail-meta {
  color: #666;
  font-size: 14px;
  margin-bottom: 25px;
}
.detail-body {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}
.detail-body img {
  max-width: 100%;
  height: auto;
}
.loading, .error {
  text-align: center;
  padding: 50px;
  color: #666;
}
.error button {
  margin-top: 15px;
  padding: 8px 20px;
  background: #004080;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
@media (max-width: 576px) {
  .detail-container {
    margin: 20px auto;
    padding: 0 10px;
  }
  .detail-card {
    padding: 20px;
  }
  .detail-title {
    font-size: 18px;
  }
}
</style>
